import { ActionReducerMap } from '@ngrx/store';

import { Association } from '@shared/models';
import { Pagination, paginationReducer } from '@shared/pagination';

import { associationsClear, associationsList, } from './assigns.actions';

export interface AssignsState {
  associations: Pagination<Association | {}>;
}
export const assignsReducer: ActionReducerMap<AssignsState> = {
  associations: paginationReducer(
    associationsList.type,
    associationsClear.type,
    associationsList.type,
  ),
};

